import { CaretLeft } from '@phosphor-icons/react'
import { Button } from 'antd'
import React from 'react'
import Calculation from './EssentialComps/Calculation'
import { leagueEventStore } from 'state/league/leagueEvent'
import FeeModal from './Modals/FeeModal'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { useCostAndFeeForLeague } from 'api/league/LeagueCostAndFee/CostAndFee'

interface Step6Props {
  handleNext: () => void
  handleBack: () => void
}

const Step6: React.FC<Step6Props> = ({ handleNext, handleBack }) => {
  const { feeModal, leagueData, setLeagueData, estimateCostPayload } =
    leagueEventStore(store => ({
      feeModal: store.feeModal,
      leagueData: store.leagueData,
      setLeagueData: store.setLeagueData,
      estimateCostPayload: store.estimateCostPayload,
    }))

  const { mutate: costAndFeeMutation, isLoading: costAndFeeMutationLoading } =
    useCostAndFeeForLeague()

  const handleSubmit = () => {
    costAndFeeMutation(
      {
        leagueId: leagueData._id,
        payload: estimateCostPayload,
      },
      {
        onSuccess: updatedData => {
          setLeagueData({ ...leagueData, ...updatedData })
          handleNext()
        },
      },
    )
  }

  return (
    <>
      <p className="mt-20px">
        Based on your event details we recommend the number of staff
      </p>

      <div className="mt-15px">
        <Calculation />
      </div>

      <div className="mt-20px flex justify-between align-center">
        <h5
          className="flex gap-10px align-center pointer"
          onClick={() => handleBack()}
        >
          <CaretLeft size={20} color="#000" />
          <span className="text-15 w-500 ">Back</span>
        </h5>
        <Button className="stepper-button" onClick={handleSubmit}>
          {costAndFeeMutationLoading ? (
            <ButtonSpinner size={20} color="#000" />
          ) : (
            'Next'
          )}
        </Button>
      </div>

      {feeModal && <FeeModal />}
    </>
  )
}

export default Step6
